import styled from 'styled-components'

export const InfiniteButtonStyles = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
